import React, {Fragment, useState} from 'react';
import { useHistory } from 'react-router-dom';

/**
 * side info left menu component
 * @param options
 * @returns {*}
 * @constructor
 */
function HeaderLeft({options}) {
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory();

    const handleKeyPress = (event) => {
      if (event.key === 'Enter' && searchTerm.trim() !== '') {
        history.push("/shop?search="+searchTerm.trim())
      }
    };
  
    

    return (
        <Fragment>
            <div className="header-left">
                <div className="side-info-bars" onClick={options.onSideInfoClick}>
                    <span/>
                    <span/>
                    <span/>
                </div>
                <div className={"side-info-content " + (options.sideInfo ? 'toggle-side-info' : '')}>
                    <button className="btn side-info-close-btn" onClick={options.onSideInfoClick}><i className="ti-close"/>
                    </button>
                    <div className="logo">
                        <img src={process.env.PUBLIC_URL + "/assets/images/logo.png"} alt=""/>
                    </div>
                    <div className="text">
                        <p>Craftsmanship and quality are at the heart of Abai.</p>
                        <ul className="info">
                            <li>Contact us: +9613654214</li>
                            <li>Mail us: abai@gmail.com</li>
                        </ul>
                        <ul className="social-links">
                            <li><a href="#"><i className="ti-facebook"/></a></li>
                            <li><a href="#"><i className="ti-twitter-alt"/></a></li>
                            <li><a href="#"><i className="ti-pinterest"/></a></li>
                            <li><a href="#"><i className="ti-vimeo-alt"/></a></li>
                        </ul>
                    </div>
                </div>
                <div className="search-area">
                    <form onSubmit={(e)=>e.preventDefault()}>
                        <button type="submit"><i className="fi flaticon-search"/></button>
                        <input type="text" placeholder="Search for.." onChange={(e) => setSearchTerm(e.target.value)} onKeyPress={handleKeyPress} />
                    </form>
                </div>
            </div>
        </Fragment>
    );
}

export default HeaderLeft;